import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import CallOutValueWithChange from 'components/molecules/CallOutValueWithChange';
import RenderingTile from 'components/molecules/RenderingTile';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import LeadGenerationExpandContainer from 'containers/dashboards/social/LeadGenerationExpandContainer';
import { LAYERTHREE } from 'constants/layers';

class LeadGenerationModule extends Component {
    render() {
        const { objective, layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social`;
        const { actions, callouts, campaigns } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', false);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutsData = hasCalloutData ? callouts.data : {};

        return (
            <ObjectiveVisibilityContainer objective={objective}
                actions={actions} layer={layer} campaigns={campaigns} expandContainer={LeadGenerationExpandContainer} >
                {/* Call Outs */}
                <Row>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-lead-generation-callouts-impressions`}
                                title="Impressions"
                                type="impressions"
                                format='0,0'
                                data={{
                                    value: calloutsData.current_impressions,
                                    change: Math.round(
                                        calloutsData.impressions_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-lead-generation-callouts-leads`}
                                title="Leads"
                                type="leadgen_grouped"
                                format='0,0'
                                helpKey='leads'
                                data={{
                                    value: calloutsData.current_leadgen_grouped,
                                    change: Math.round(
                                        calloutsData.leadgen_grouped_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                    <Col xs={12} md={4}>
                        {hasCalloutData ? (
                            <CallOutValueWithChange
                                exportName={`${stub}-lead-generation-callouts-cost-per-lead`}
                                title="Cost / Lead"
                                type="cost_per_leadgen_grouped"
                                helpKey='cost_per_lead'
                                data={{
                                    value: calloutsData.current_cost_per_leadgen_grouped,
                                    change: Math.round(calloutsData.cost_per_leadgen_grouped_per_delta, 0),
                                    completeData,
                                    sparkline: calloutsData.sparkline,
                                    calloutWindow
                                }}
                                format='$0.00'
                                animateDuration={2000} />
                        ) : (
                            <RenderingTile height='180px' />
                        )}
                    </Col>
                </Row>


            </ObjectiveVisibilityContainer>
        );
    }
}

LeadGenerationModule.propTypes = {
    module: PropTypes.shape({
        callouts: PropTypes.object,
    }).isRequired
};

export default LeadGenerationModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/LeadGenerationModule.js